import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatTable } from '@angular/material/table';
import { WorkOrder, WorkOrderDeliveryDate } from '@cots/planning/resources/work-order';
import { PlanningDetailService } from '../planning-detail.service';

@Component({
  selector: 'planning-splits',
  templateUrl: './planning-splits.component.html',
  styleUrls: ['./planning-splits.component.less'],
    providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PlanningSplitsComponent),
      multi: true
    }
  ]
})
export class PlanningSplitsComponent implements OnInit, ControlValueAccessor {
  @Input() workOrder: WorkOrder;
  @Input() isAllPlanned: boolean;
  @Output() previewTraveler = new EventEmitter<WorkOrderDeliveryDate>();
  @Output() doRelease = new EventEmitter<WorkOrderDeliveryDate>();
  @Output() unrelease = new EventEmitter<WorkOrderDeliveryDate>();

  constructor(private detailService: PlanningDetailService) { }

  ngOnInit(): void {
  }

  public get unassignedQty(): number {
    const qty = this.detailService.getProductQuantity(this.workOrder.product);
    return qty - this.value.reduce((acc, x) => acc + x.quantity, 0);
  }

  public value: WorkOrderDeliveryDate[];
  writeValue(item: WorkOrderDeliveryDate[]): void {
    this.value = item ? structuredClone(item) : [];
  }

  private onChange: (value: WorkOrderDeliveryDate[]) => void;
  private onTouched: () => void;

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  remove(index: number): void {
    this.value = this.value.filter((_, i) => i !== index);
    this.onChange(this.value);
  }

  @ViewChild('matTable') matTable: MatTable<any>;
  add(): void {
    this.value = [...this.value, {
      quantity: this.unassignedQty,
      dueDate: null
    }];

    this.onChange([...this.value]);
  }

}
